// styles.ts

import { makeStyles } from "@mui/styles";

interface Props {
  marginBottom?: string;
}

export const useStyles = makeStyles(() => ({
  formControl: {
    width: "100%",
    marginBottom: (props: Props) => props.marginBottom || "20px",
  },
  locationIcon: {
    color: "action.active",
    marginRight: 8,
  },
  option: {
    display: "flex",
    alignItems: "center",
  }
}));
